import PropTypes from 'prop-types';
import HR from 'UIComponents/elements/HR';
import CloseTicketField from '../fields/CloseTicketField';
import ProductAreaField from '../fields/ProductAreaField';
import ResolutionField from '../fields/ResolutionField';
import RoadblockField from '../fields/RoadblockField';
import TicketSubjectField from '../fields/TicketSubjectField';

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function MainView(props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx(ProductAreaField, {})
    }), /*#__PURE__*/_jsx("div", {
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx(RoadblockField, {})
    }), /*#__PURE__*/_jsx("div", {
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx(ResolutionField, {})
    }), /*#__PURE__*/_jsx(HR, {
      className: "m-top-8 m-bottom-4"
    }), /*#__PURE__*/_jsx("div", {
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx(TicketSubjectField, {})
    }), props.isCloseTicketDisabled ? null : /*#__PURE__*/_jsx(CloseTicketField, {})]
  });
}
MainView.propTypes = {
  isCloseTicketDisabled: PropTypes.bool
};
MainView.defaultProps = {
  isCloseTicketDisabled: false
};
export default MainView;